<div
  id="header"
  class="relative flex justify-between items-center px-2 md:pl-5 md:pr-6 py-1 w-full h-full"
  [ngClass]="
    showLegend
      ? 'text-white'
      : isSummaryRoute
        ? 'text-gray-900 bg-[#e9f3fb]'
        : isCartRoute
          ? 'text-gray-900 bg-gray-100'
          : 'text-gray-900 bg-white'
  ">
  @if (showLegend) {
    <div
      aria-hidden="true"
      class="-z-10 absolute inset-x-0 top-0 h-[132px] md:h-[176px] bg-[linear-gradient(to_bottom,rgba(0,0,0,0.6),rgba(0,0,0,0))] pointer-events-none"></div>
  }

  <div class="flex items-center">
    @if (backBtn === 'checkout') {
      <button
        data-cy="back-to-seat-selection-button"
        aria-label="Back to seat selection"
        class="flex flex-none justify-center items-center bg-transparent hover:bg-current/10 disabled:opacity-30 mr-3 border border-current/40 rounded-full w-8 h-8 disabled:hover:transform-none hover:scale-95 transition-transform"
        (click)="goBack()">
        <svg
          class="w-3 h-3"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg">
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M15 19l-7-7 7-7"></path>
        </svg>
      </button>
    }

    <div class="hidden md:flex items-center mr-6">
      @if (!isNotFoundRoute()) {
        <ng-container>
          <img
            [ngSrc]="configurationService.configuration.logo"
            alt="Club logo"
            class="h-12"
            width="48"
            height="48"
            [priority]="false" />
          <div class="flex items-center h-10">
            <div class="flex flex-col gap-1 ml-3 min-w-max leading-tight">
              <h3 class="text-base leading-4 font-extrabold">
                {{ configurationService.configuration.clientName }}
              </h3>
              <span class="text-sm leading-4 font-medium">Group Sales</span>
            </div>
            @if (!landing && event) {
              <ng-container>
                <div class="mx-5 border-current border-l h-full"></div>
                <h5
                  [title]="event.description"
                  class="max-w-64 overflow-hidden font-bold text-sm text-nowrap">
                  <span class="font-normal">Event:&nbsp;</span
                  >{{ event.description }}
                </h5>
                <div class="mx-5 border-current border-l h-full"></div>
                @if (showDateAsTbd) {
                  <h5
                    class="hidden lg:flex items-center gap-x-2 mr-2 font-bold text-sm text-nowrap">
                    <span class="font-normal">Tickets for</span>
                    <span>{{ eventDateTbdText }}</span>
                  </h5>
                } @else {
                  <h5
                    [title]="formattedEventDate"
                    class="hidden lg:flex items-center gap-x-2 mr-2 font-bold text-sm text-nowrap">
                    <span class="font-normal">Tickets for</span>
                    <span>{{ eventWeekday }}</span>
                    <svg
                      class="flex-none w-3.5 h-3.5"
                      viewBox="0 0 14 14"
                      fill="currentColor"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M6.99998 14C3.13413 14 0 10.8663 0 6.99998C0 3.13366 3.13413 0 6.99998 0C10.8658 0 14 3.13413 14 6.99998C14 10.8658 10.8658 14 6.99998 14ZM12.6 6.99998C12.6 3.9072 10.0928 1.4 6.99998 1.4C3.9072 1.4 1.4 3.9072 1.4 6.99999C1.4 10.0928 3.9072 12.6 6.99998 12.6C10.0928 12.6 12.6 10.0928 12.6 6.99999V6.99998ZM9.79998 6.29999C10.1866 6.29999 10.5 6.61339 10.5 6.99998C10.5 7.38658 10.1866 7.69998 9.79998 7.69998H7.69998C6.92999 7.69998 6.29999 7.06998 6.29999 6.29999V3.49999C6.29999 3.11339 6.61339 2.79999 6.99998 2.79999C7.38658 2.79999 7.69998 3.11339 7.69998 3.49999V6.29999H9.79998Z" />
                    </svg>
                    <span>{{ eventTimeOfDay }}.</span>
                    <span>{{ eventMonthDay }}</span>
                    <span class="font-normal text-xs">
                      (All Times {{ eventTimeZone }}. Subject to change.)
                    </span>
                  </h5>
                }
              </ng-container>
            }
          </div>
        </ng-container>
      }
    </div>
    <div class="md:hidden flex items-center mr-6">
      @if (!isNotFoundRoute()) {
        <ng-container>
          <img
            [ngSrc]="configurationService.configuration.logo"
            [priority]="true"
            alt="Club logo"
            width="32"
            height="32" />
          <h5 class="ml-2 min-w-max">
            {{ configurationService.configuration.clientName }}
          </h5>
        </ng-container>
      }
    </div>
  </div>

  @if (landing && isAuthenticated) {
    <div
      class="hidden md:flex flex-col items-center absolute inset-x-0 mx-auto w-fit text-sm text-center leading-[18px]">
      <span class="font-medium">
        Welcome, <span class="font-extrabold">{{ patronName }}</span>
      </span>
      @if (patronEmail) {
        <span class="font-medium text-main">{{ patronEmail }}</span>
      }
    </div>
  }

  @if (showLegend) {
    <div class="flex items-center gap-x-3">
      @if (!is3dOpen) {
        <div class="flex items-center gap-x-2">
          <button
            data-cy="open-legend-modal-button"
            (click)="openLegend()"
            class="flex justify-center items-center bg-black/40 border border-[#707070] rounded-full w-22 h-7 text-white text-xs hover:scale-95 transition-transform">
            Legend
          </button>
          @if (showTutorialButton) {
            <button
              data-cy="open-tutorial-modal-button"
              (click)="openTutorialQuestion()">
              <img
                ngSrc="/assets/img/information-icon.svg"
                alt="Information icon"
                class="disabled:opacity-30 disabled:hover:transform-none hover:scale-95 transition-transform"
                width="25"
                height="25" />
            </button>
          }
        </div>
      }

      @if (!is3dOpen) {
        @if (isAuthenticated) {
          <div class="hidden md:flex items-center">
            <button
              data-cy="header-sign-out-button"
              class="btn-main-dark h-7 py-0 text-xs"
              (click)="signOut()">
              Sign out
            </button>
          </div>
        } @else {
          <div class="hidden md:flex items-center">
            <button
              data-cy="header-sign-in-button"
              class="btn-main-dark h-7 py-0 text-xs"
              (click)="signIn()">
              Sign in
            </button>
          </div>
        }
      }

      @if (upgradesService.upgrades?.length) {
        <div class="hidden md:flex items-center">
          <app-upgrades />
        </div>
      }
    </div>
  }

  @if (
    !showLegend &&
    (showTutorialButton ||
      showPrivateSellingActions ||
      landing ||
      (showUserInfo && isAuthenticated) ||
      (showUserInfo && !isAuthenticated))
  ) {
    <div class="flex items-center gap-x-3">
      @if (showUserInfo && isAuthenticated) {
        <span
          [title]="patronName"
          class="hidden sm:block max-w-40 text-sm text-nowrap truncate">
          Hi, {{ patronName }}
        </span>
      }
      @if (showTutorialButton || showPrivateSellingActions) {
        <button
          data-cy="open-tutorial-modal-button"
          (click)="openTutorialQuestion()">
          <img
            ngSrc="/assets/img/information-icon-navy.svg"
            alt="Information icon"
            class="disabled:opacity-30 disabled:hover:transform-none hover:scale-95 transition-transform"
            width="24"
            height="24" />
        </button>
      }
      @if ((showUserInfo || landing) && isAuthenticated) {
        <button
          data-cy="header-sign-out-button"
          class="btn-main-dark h-7 py-0 text-xs"
          (click)="signOut()">
          Sign out
        </button>
      }
      @if ((showUserInfo || landing) && !isAuthenticated) {
        <button
          data-cy="header-sign-in-button"
          class="btn-main-dark h-7 py-0 text-xs"
          (click)="signIn()">
          Sign in
        </button>
      }
    </div>
  }
</div>
